import { useAuthOptions } from 'hooks/useAuthOptions';
import { useCarValuationToolContext } from '../../CarValuationTool.context';

import { AUTHENTICATION_STATUSES } from '../../../../../../../components/PageWrappers/AdDetails/types';

/**
 * This hook is responsible for taking a registration number inputted by the user.
 *
 * If the user is authenticated, we store that value in state. This state in then used to prepopulate the car valuation modal.
 *
 * If the user is unauthenticated, we store that value in session storage which is set in state once the user signs in successfully.
 *
 * An initial value should only be available if the user has previously submitted a request for a valuation while unauthenticated.
 *
 * @returns the submit handler for the registration input and an initial registration number based on session storage, if any.
 *
 */
const useRegistrationNumber = () => {
  const {
    setIsValueCarModalOpen,
    setRegistrationNumber,
    setCarValuationToolSessionStorageData,
    sessionStorageRegistrationNumber,
  } = useCarValuationToolContext();

  const { status, handleLogin } = useAuthOptions();

  const onSubmit = (registrationNumber: string) => {
    if (status === AUTHENTICATION_STATUSES.AUTHENTICATED) {
      setIsValueCarModalOpen(true);
      setRegistrationNumber(registrationNumber);
      return;
    }
    if (status === AUTHENTICATION_STATUSES.UNAUTHENTICATED) {
      setCarValuationToolSessionStorageData(registrationNumber);
      handleLogin();
    }
  };

  const initialRegistrationNumber = sessionStorageRegistrationNumber ?? '';

  return {
    onSubmit,
    initialRegistrationNumber,
  };
};

export { useRegistrationNumber };
